import { render } from "./UserSearchHeader.vue?vue&type=template&id=78e49084"
import script from "./UserSearchHeader.vue?vue&type=script&lang=js"
export * from "./UserSearchHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__